// config.js is imported by both the browser (via Vite) and Node.js scripts.
// import.meta.env is a Vite-only object; the typeof guard prevents a ReferenceError in Node.

const storage = {
  baseUrl:
    typeof import.meta.env !== 'undefined'
      ? import.meta.env.VITE_MP3_BASE_URL || '/audio'
      : '/audio',

  getBaseUrl() {
    return this.baseUrl
  },
}

const config = {
  isDevelopment: typeof import.meta.env !== 'undefined' ? import.meta.env.DEV : true,
  isProduction: typeof import.meta.env !== 'undefined' ? import.meta.env.PROD : false,
  storage,
}

export default config
